import type { RenderCellOptions } from '@talos/kyoko';

export const CREDIT_MARKET_ACCOUNT_COL_ID = 'MarketAccount';
export const CREDIT_CURRENCY_COL_ID = 'Currency';
export const CREDIT_EXPOSURE_DEFINITION_COL_ID = 'ExposureDefinition';
export const CREDIT_EXPOSURE_COL_ID = 'exposureAgg';
export const CREDIT_REMAINING_CREDIT_COL_ID = 'effectiveRemainingCredit';
export const CREDIT_USAGE_COL_ID = 'creditUsage';

export const VISIBLE_COLUMN_RENDER_OPTIONS = { overrideColumnVisibility: true } satisfies RenderCellOptions;
